import React from 'react';
import { IconProps } from '../types/types';

const AVABSC: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#2D2D4F"/><path d="M8.532 7.565H5.809a.293.293 0 0 1-.22-.095.327.327 0 0 1-.089-.232V5.327a.34.34 0 0 1 .09-.232A.306.306 0 0 1 5.81 5h7.763c.245 0 .481.104.655.288.174.183.272.433.272.693v1.257a.34.34 0 0 1-.09.232.307.307 0 0 1-.22.095h-2.734v8.108a.341.341 0 0 1-.09.232.306.306 0 0 1-.219.095H9.46a.904.904 0 0 1-.655-.288 1.011 1.011 0 0 1-.272-.693V7.565Z" fill="#fff"/></svg>
);

export default AVABSC;
